import React from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import ChartComponent from './ChartComponent';

const isNan = n => n === null || isNaN(n);

const LineChartComponent = ({
  data,
  series,
  labels,
  stacked,
  orphanPointRadius,
  pointOptions,
  onClick,
  lines,
  options,
  ...passthruProps
}) => {
  const singlePoint = labels.length === 1;

  const dataset = series.map((s, i) => {
    let { pointRadius } = s;

    if (pointRadius !== undefined && !Array.isArray(pointRadius)) {
      // Make orphaned points use the specific radius
      pointRadius = data[i].map((val, j) => {
        if (j > 0 &&
            j < data[i].length &&
            isNan(data[i][j - 1]) &&
            isNan(data[i][j + 1])
        ) {
          return orphanPointRadius || pointRadius;
        } else {
          return pointRadius;
        }
      });

      s.pointRadius = pointRadius;
    }

    let dset = {
      pointBorderColor: '#000',
      lineTension: 0,
      fill: false,
      pointHitRadius: 4,
      ...s,
      data: data[i]
    };

    if (pointOptions && pointOptions.length === data.length) {
      dset = {
        ...dset,
        ...pointOptions[i]
      };
    }

    return dset;
  });

  const dataObj = {
    labels: labels,
    datasets: dataset
  };

  const defaultOptions = {
    tooltips: {
      mode: 'index',
      intersect: false
    },
    hover: { intersect: false, },
    scales: {
      yAxes: [
        {
          afterDataLimits: scale => {
            if (scale.min === 0 || !scale.ticks || scale.ticks.length <= 1) {
              return;
            }

            const tickSize = Math.abs(scale.ticks[0] - scale.ticks[1]);
            scale.min = Math.max(0, scale.min - tickSize);
          },
          stacked: stacked
        }
      ],
      xAxes: [{ offset: singlePoint }]
    },
  };

  return (
    <ChartComponent
      type="line"
      data={dataObj}
      options={merge(defaultOptions, options)}
      onClick={onClick}
      lines={lines}
      panelOptions={passthruProps.panelOptions}
    />
  );
};

LineChartComponent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  series: PropTypes.arrayOf(PropTypes
    .shape({ pointRadius: PropTypes.number })).isRequired,
  pointOptions: PropTypes.array,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  stacked: PropTypes.bool,
  orphanPointRadius: PropTypes.number,
  onClick: PropTypes.func,
  options: PropTypes.object,
  lines: PropTypes.arrayOf(PropTypes.shape({
    xAxisValue: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
  }))
};

export default LineChartComponent;


// WEBPACK FOOTER //
// src/Components/LineChartComponent.jsx